import { apiFetch } from './apiFetch';

export async function validateReciever(phoneNumber) {
  try {
    const response = await apiFetch(
      `/receiver/check?phone_number=${phoneNumber}`,
    );

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();

    // Assuming your API returns { valid: true/false }
    return data.is_valid === true;
  } catch (error) {
    console.error('Error validating phoneNumber:', error);
    throw error;
  }
}
